export default "__VITE_ASSET__BgUeHdgQ__"